import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReservationPluginService } from './reservation-plugin.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private appConfig;

  constructor(private http: HttpClient, private reservationPluginService: ReservationPluginService,
    private translationService: TranslationService) { }

  public loadAppConfig() {
    return new Promise((resolve) => {
      this.http.get('assets/config.json').subscribe(
        data => {
          this.appConfig = data;
          const url = new URL(window.location.href);
          const locationId = url.searchParams.get('locationId');
          const systemId = url.searchParams.get('systemId');
          if (locationId) {
            this.appConfig.locationId = locationId;
          }
          if (systemId) {
            this.appConfig.systemId = systemId;
          }
          this.reservationPluginService.setAppBase(this.appConfig);
          this.translationService.setAppBase(this.appConfig);
          resolve(true);
        }
      );
    });
  }
}
